export default "__VITE_ASSET__05fbd6cd__"